import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import TopNavButton from '../../common/components/TopNavButton';
import MessagesNavButton from '../components/MessagesNavButton';
import LinkButton from 'flarum/common/components/LinkButton';
import { isMobileWebview } from '../../util';
import { urls } from '@speareducation/util';

export default () => {
  extend(HeaderSecondary.prototype, 'items', (items) => {
    if (app.session.user) {
      items.remove('session');

      items.add('chat', <MessagesNavButton />);

      items.add(
        'profile',
        <TopNavButton icon="fas fa-user" href={app.route.user(app.session.user)}>Profile</TopNavButton>,
      );

      items.add(
        'settings',
        <TopNavButton icon="fas fa-cog" href="/settings">Settings</TopNavButton>,
      );

      if (app.forum.attribute('adminUrl')) {
        items.add(
          'administration',
          <TopNavButton icon="fas fa-wrench" href={app.forum.attribute('adminUrl')} target="_blank">Admin</TopNavButton>,
        );
      }

      if (isMobileWebview()) {
        const communityUrl = urls.getBaseUrl('community');
        const logoutUrl = `${urls.getBaseUrl('accounts')}/logout?redirect=${encodeURIComponent(communityUrl)}`;
        items.add('logOut', <TopNavButton icon="fas fa-sign-out-alt" href={logoutUrl} external={true}>Log Out</TopNavButton>,)
      }

    } else {
      const logInLink = <LinkButton className="Button Button--link" href={`${urls.getBaseUrl('accounts')}/login`} target="_blank">{app.translator.trans('core.forum.header.log_in_link')}</LinkButton>;
      const signUpLink = <LinkButton className="Button Button--link" href={`${urls.getBaseUrl('www')}/sign-up`} target="_blank">{app.translator.trans('core.forum.header.sign_up_link')}</LinkButton>;

      items.has('logIn') ? items.setContent('logIn', logInLink) : items.add('logIn', logInLink);
      items.has('signUp') ? items.setContent('signUp', signUpLink) : items.add('signUp', signUpLink);
    }
  });

  extend(HeaderSecondary.prototype, 'view', (vnode) => {
    if (isMobileWebview() && window.innerWidth < 768) {
      const homeLink = 
      <LinkButton className="Button Button--link mobile-webview-homeLink" href={urls.getBaseUrl('community')}>
        <span class="spear-talk-logo">
          <svg width="26" height="25" viewBox="0 0 26 25" fill="#ffffff" xmlns="http://www.w3.org/2000/svg">
              <path d="M23.1562 21.8359C24.8828 20.8203 26 19.2969 26 17.5703C26 16.25 25.3906 15.082 24.375 14.1172C22.2422 17.6719 17.5195 20.1602 11.9336 20.4141C13.3047 21.9883 15.6914 23.0547 18.3828 23.0547C19.0938 23.0547 19.8047 22.9531 20.4141 22.8516C21.7852 23.918 23.6133 24.2734 24.1719 24.3242C24.832 24.4258 24.5273 23.8164 23.8672 23.0547C23.4609 22.6484 23.2578 22.2422 23.1562 21.8359ZM24.3242 8.83594C24.3242 3.96094 18.8906 0 12.1875 0C5.43359 0 0 3.96094 0 8.83594C0 11.6797 1.77734 14.1172 4.57031 15.7422C4.36719 16.3008 4.0625 17.0117 3.45312 17.7227C2.33594 18.9922 1.92969 19.9062 2.94531 19.8047C3.80859 19.7031 6.80469 19.1445 8.9375 17.3672C9.95312 17.5703 11.0703 17.7227 12.1367 17.7227C18.8906 17.6719 24.3242 13.7109 24.3242 8.83594ZM6.19531 11.1211C5.02734 11.1211 4.0625 10.1562 4.0625 8.98828C4.0625 7.82031 5.02734 6.80469 6.19531 6.80469C7.41406 6.80469 8.37891 7.82031 8.37891 8.98828C8.37891 10.1562 7.41406 11.1211 6.19531 11.1211ZM18.0273 6.80469C19.1953 6.80469 20.2109 7.82031 20.2109 8.98828C20.2109 10.1562 19.1953 11.1211 18.0273 11.1211C16.8594 11.1211 15.8945 10.1562 15.8945 8.98828C15.8945 7.82031 16.8086 6.80469 18.0273 6.80469ZM9.90234 8.98828C9.90234 7.82031 10.8672 6.80469 12.0859 6.80469C13.2539 6.80469 14.2188 7.82031 14.2188 8.98828C14.2188 10.1562 13.2539 11.1211 12.0859 11.1211C10.8672 11.1211 9.90234 10.1562 9.90234 8.98828Z" fill="white"/>
          </svg>
        </span>
          Spear Talk
      </LinkButton>;
  
      vnode.children.unshift(homeLink);
    }
  });

  extend(HeaderSecondary.prototype, 'oncreate', () => {
    const handleScroll = () => {
      const header = document.getElementById('spear-header');
      
      if (header && window.scrollY > 50) {
        header.classList.add('hide-spear-header');
      } else {
        header?.classList.remove('hide-spear-header');
      }
      
      const sideNav = document.querySelector('.sideNav ul');
      const lastDiscussion = document.querySelector('.DiscussionList ul')?.lastElementChild;
      const lastDiscussionBottom = lastDiscussion?.getBoundingClientRect().bottom;

      const shouldNavScroll = sideNav?.offsetHeight + 50 < lastDiscussionBottom;
      const scrollDistance = window.scrollY - 50;
  
      // Scroll sideNav with the page
      if (window.scrollY > 110 && window.innerWidth >= 992) {
        shouldNavScroll && (sideNav.style.marginTop = `${scrollDistance}px`)
      } else if (window.innerWidth >= 992) {
        sideNav?.style && (sideNav.style.marginTop = '32px');
      }
    };
  
    window.addEventListener('scroll', handleScroll);
  });
  
};
